import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { DcButton, PixelFactoryContext } from 'pixel-base'
import {
  getDemoDataBatches,
  getDemoDataStatus,
  removeDemoData,
} from 'utils/api-routes-accounts'
import FinancePageShell from '../../components/FinancePageShell'
import FinanceStatusBadge from '../../components/FinanceStatusBadge'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { DemoSeedBatch } from '../../types/finance'

const DemoBatchDetail = () => {
  const { batchId } = useParams()
  const navigate = useNavigate()
  const pixelFactory = React.useContext(PixelFactoryContext) as any
  const batches = useFinanceObservable<DemoSeedBatch[]>(() =>
    getDemoDataBatches(),
  )
  const status = useFinanceObservable<any>(() => getDemoDataStatus())
  const batch = React.useMemo(
    () => (batches.data || []).find((item) => item.batch_id === batchId),
    [batches.data, batchId],
  )

  const remove = () => {
    removeDemoData({ batch_id: batchId }).subscribe({
      next: () => {
        pixelFactory?.showSuccess?.('Demo data removed')
        navigate('/finance/demo-data')
      },
      error: () => pixelFactory?.showFailure?.('Unable to remove demo data'),
    })
  }

  return (
    <FinancePageShell
      title={batch ? `Demo Batch ${batch.batch_id}` : 'Demo Batch'}
      breadcrumbs={[
        { name: 'Finance', active: false },
        { name: 'Demo Data', active: false },
        {
          name: batch ? `Demo Batch ${batch.batch_id}` : 'Demo Batch',
          active: true,
        },
      ]}
      isLoading={batches.loading || status.loading}
    >
      {batch && (
        <div style={{ display: 'grid', gap: 20 }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 16,
            }}
          >
            <div>
              <strong>Profile</strong>
              <div>{batch.profile}</div>
            </div>
            <div>
              <strong>Tag</strong>
              <div>{batch.tag || '--'}</div>
            </div>
            <div>
              <strong>Status</strong>
              <div>
                <FinanceStatusBadge status={batch.status} />
              </div>
            </div>
            <div>
              <strong>Created At</strong>
              <div>{formatFinanceDate(batch.created_at)}</div>
            </div>
            <div>
              <strong>Removed At</strong>
              <div>{formatFinanceDate(batch.removed_at)}</div>
            </div>
            <div>
              <strong>Demo Mode</strong>
              <div>{status.data?.status || '--'}</div>
            </div>
          </div>
          <div>
            <strong>Operational Status</strong>
            <div style={{ marginTop: 8, color: '#4b5563' }}>
              {status.data?.cleanup_required_before_live_usage
                ? 'Cleanup required before live usage'
                : 'No cleanup required'}
            </div>
          </div>
          {batch.status === 'installed' && (
            <DcButton variant="outline-danger" onClick={remove}>
              Remove Batch
            </DcButton>
          )}
        </div>
      )}
    </FinancePageShell>
  )
}

export default DemoBatchDetail
